import React, { useEffect, useRef } from "react";
import CassetteTape from "./CassetteTape";
import "./styles/CassetteTapeLoadingOverlay.css";

interface LoadingOverlayProps {
  backgroundStyle: React.CSSProperties;
}

const CassetteTapeLoadingOverlay = ({
  backgroundStyle,
}: LoadingOverlayProps) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    const audio = new Audio("/assets/themes/tape/audio/rewind.mp3");
    audio.loop = true;
    audioRef.current = audio;
    audio.play().catch(() => {
      // pause silently if autoplay is blocked
    });
    return () => {
      audio.pause();
      audioRef.current = null;
    };
  }, []);

  return (
    <div className="tape-loading-overlay" style={backgroundStyle}>
      <div className="tape-loading-overlay-cassette">
        <CassetteTape
          isPlaying={false}
          isRewinding={true}
          isFastForwarding={false}
        />
      </div>
    </div>
  );
};

export default CassetteTapeLoadingOverlay;
